import { Directive, OnDestroy, effect, inject } from '@angular/core';
import { UiBottomSheetComponent } from '@ui';
import { MobileBackButtonService } from '../services/mobile-back-button.service';
import { MobileBackButtonModels } from '../models/mobile-back-button.model';

@Directive({
  selector: 'ui-bottom-sheet[appBackClose]',
  standalone: true,
})
export class BackCloseDirective implements OnDestroy {
  private readonly uiBottomSheetComponent = inject(UiBottomSheetComponent);
  private readonly mobileBackButtonService = inject(MobileBackButtonService);

  private unregisterOverlay: (() => void) | null = null;

  private readonly handleBack: MobileBackButtonModels.OverlayHandler = () => {
    this.uiBottomSheetComponent.closeEmit.emit();

    return true;
  };

  constructor() {
    effect(() => {
      if (this.uiBottomSheetComponent.open()) {
        this.register();
      } else {
        this.release();
      }
    });
  }

  public ngOnDestroy(): void {
    this.release();
  }

  private register(): void {
    if (this.unregisterOverlay) {
      return;
    }

    this.unregisterOverlay = this.mobileBackButtonService.registerOverlay(
      this.handleBack,
    );
  }

  private release(): void {
    this.unregisterOverlay?.();
    this.unregisterOverlay = null;
  }
}
